/**
 * Пул «Люди»: боксы людей на ПОЛНЫХ кадрах камер — дообучение детектора людей.
 *
 * Строки создаются импортом подборки с уже заполненными боксами (наш детектор + внешняя
 * предразметка); очередь — ещё не просмотренные. Координаты — доли 0–1 кадра (`image_url`).
 */
import { axiosInstance } from './api';
import type { BoxView } from './boxPool';

export type PersonBoxSource = 'ours' | 'fixed' | 'external' | 'human';

export interface PersonBox {
  id: number | null;
  x0: number; y0: number; x1: number; y1: number;
  score: number;
  weak: boolean;
  deleted: boolean;
  added: boolean;
  source: PersonBoxSource;
}

export interface PersonItem {
  key: string;
  label_id: number;
  zone_id: number; zone: string | null;
  camera_id: number; camera: string | null;
  frame_id: number;
  ts: string | null;
  image_url: string | null;
  boxes: PersonBox[];
  label: { status: 'modified' | 'correct'; annotated_by: string | null; annotated_at: string | null } | null;
}

type Counts = { queue: number; modified: number; correct: number };

export interface PeopleZonesResponse {
  zones: ({ zone_id: number; zone: string | null } & Counts)[];
  collections: ({ id: number; name: string } & Counts)[];
  totals: Counts;
}

export interface PeopleSamples {
  items: PersonItem[];
  facets: Counts;
  view: BoxView; total: number; page: number; page_size: number;
}

export const getPeoplePoolZones = () =>
  axiosInstance.get<PeopleZonesResponse>('/ml_models_lifecycle/people/pool/zones/');

export const getPeoplePoolSamples = (params: {
  zone_id: number | null; collection: number | null; view: BoxView; page: number; page_size: number;
}) =>
  axiosInstance.get<PeopleSamples>('/ml_models_lifecycle/people/pool/samples/', {
    params: {
      ...(params.zone_id ? { zone_id: params.zone_id } : {}),
      ...(params.collection ? { collection: params.collection } : {}),
      view: params.view, page: params.page, page_size: params.page_size,
    },
  });

/** status null — снять разметку, кадр вернётся в очередь (боксы остаются). */
export type PersonLabelDelta = {
  label_id: number; status: 'modified' | 'correct' | null; boxes?: PersonBox[];
};

export const peoplePoolAnnotate = (items: PersonLabelDelta[]) =>
  axiosInstance.post<{ saved: number; removed: number }>(
    '/ml_models_lifecycle/people/pool/annotate/', { items });
